import { Stepper as MuiStepper, type StepperProps, styled } from '@lingoda/ui';

const StepperStyled = styled(MuiStepper)(({ theme }) => ({
    background: theme.colors.border['progress-bold'],
}));

export const Stepper = ({ connector, alternativeLabel, ...props }: StepperProps) => (
    <StepperStyled connector={null} alternativeLabel {...props} />
);
